export class GridModel<T> {
    data: T[];
    count: number;
    message: string;
    success: boolean;

    constructor(data: T[], count: number) {
        this.data = data;
        this.count = count;
    }
}
